import React from "react";
import { List, ListItemButton, CircularProgress } from "@mui/material";
import { DatasetVersionStringForList } from "./DatasetVersionStringForList";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    nonListContent: {
        padding: "10px",
    },
});

type DatasetDerivedListProps<ObjectT> = {
    className?: string;

    dataNotYetLoadedMessage?: string;
    emptyListMessage?: string;
    errorMessage?: string;

    datasetStatus: "idle" | "loading" | "failed" | "succeeded";
    datasetVersion: string;
    datasetType: string;

    objectList: ObjectT[];
    selectObject: (object: ObjectT | undefined) => void;
    isActiveObject: (obj: ObjectT) => boolean;

    extractObjectKey: (object: ObjectT) => string;
    extractObjectLabel: (object: ObjectT) => string;

    sortByLabel?: boolean;
};

export default function DatasetDerivedList<T>(props: DatasetDerivedListProps<T>): JSX.Element {
    const classes = useStyles();

    if (props.datasetStatus === "loading") {
        return <CircularProgress className={classes.nonListContent} style={{ alignSelf: "center" }} />;
    } else if (props.datasetStatus === "idle") {
        return <div className={classes.nonListContent}>{props.dataNotYetLoadedMessage}</div>;
    } else if (props.datasetStatus === "failed") {
        return <div className={classes.nonListContent}>{props.errorMessage}</div>;
    }

    const displayList = props.sortByLabel
        ? [...props.objectList].sort((a, b) =>
              props.extractObjectLabel(a).localeCompare(props.extractObjectLabel(b))
          )
        : props.objectList;

    return (
        <>
            <List className={props.className}>
                {displayList.length ? (
                    displayList.map((object: T) => (
                        <ListItemButton
                            key={props.extractObjectKey(object)}
                            onClick={() => props.selectObject(object)}
                            selected={props.isActiveObject(object)}
                        >
                            {props.extractObjectLabel(object)}
                        </ListItemButton>
                    ))
                ) : (
                    <div className={classes.nonListContent}>
                        <b>{props.emptyListMessage}</b>
                    </div>
                )}
            </List>
            {props.datasetVersion && (
                <DatasetVersionStringForList datasetType={props.datasetType} version={props.datasetVersion} />
            )}
        </>
    );
}
